import { api, apiCall, apiActionDispatcher } from '../actions/api';
import * as types from '../actions/types';
import * as sonarHelpers from '../helpers/sonar';
import {
  buildsByTypesAndProducts,
  getBuildsByTypeAndBuildNumber
} from '../reducers';

export const fetchSonarDataDispatcher = apiActionDispatcher({
  actionTypes: types.fetchSonarDataActionTypes,
  responseHandler: (response) => response,
  errorMessage: 'Failed to retrieve data from Sonar API.\
  Ensure you\'re connected to the server.'
});

export const fetchSonarDataByBuilds =
(currentBuild) => async (dispatch, getState) => {
  const builds = buildsByTypesAndProducts(getState());
  const buildsByTypeAndBuildNum =
    getBuildsByTypeAndBuildNumber(getState())(currentBuild);
  if (!buildsByTypeAndBuildNum) return [];

  let product;
  //grab current and baseline build info based on product being investigated
  switch (currentBuild.product) {
    case 'axiom':
      product = 'process';
      break;
    case 'ief':
      product = 'ief_engine';
      break;
  }

  const currentBuildInfo =
    buildsByTypeAndBuildNum.find(b => b.product === product);
  const baselineBuild =
    builds.Production[product]
      .find(b => b.id < currentBuildInfo.id &&
        b.updated_at < currentBuildInfo.updated_at);
  //return empty array in case where we cannot find desired property
  if (baselineBuild === undefined || baselineBuild.id === undefined) {
    return [];
  }

  return await dispatch(apiCall(
    fetchSonarDataDispatcher,
    api.sonar.fetchSonarDataByBuilds,
    (state) => {
      return sonarHelpers.hasBeenLoaded(
        state, baselineBuild.id, currentBuildInfo.id);
    },
    null,
    null,
    [baselineBuild.id, currentBuildInfo.id]
  ));
};



// WEBPACK FOOTER //
// src/actions/sonar.js